import classnames from "classnames";
import React from "react";
import Swiper, { SwiperOptions } from "swiper";
import "swiper/dist/css/swiper.css";
import "./index.scss";

interface IProps {
  option: SwiperOptions;
  children: React.ReactNode;
  className?: string;
  id: string;
  position?: string;
}

const DEFAULT_OPTION = {
  effect: "slide" as SwiperOptions["effect"],
  loop: true,
  autoplay: {
    delay: 3000,
  },
  slidesPerView: "auto" as SwiperOptions["slidesPerView"],
  speed: 300,
  simulateTouch: false,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    hideOnClick: true,
  },
};

export default class MySwiper extends React.Component<IProps> {
  public mySwiper = {} as Swiper;
  public myRef = null as HTMLDivElement | null;
  public option = DEFAULT_OPTION as SwiperOptions;

  public firstElement = null as HTMLDivElement | null;
  public lastElement = null as HTMLDivElement | null;
  public dispatchFirstElement: (evt: MouseEvent) => void = () => {
    // 初始化dispatch
  };
  public dispatchLastElement: (evt: MouseEvent) => void = () => {
    // 初始化dispatch
  };

  public bindElementEvent = () => {
    const { length } = this.props.children as React.ReactNode[];
    if (!this.myRef || !this.option.loop || !length) {
      return;
    }

    const firstSlideElements = this.myRef.querySelectorAll(
      "[data-swiper-slide-index='0']",
    ) as NodeListOf<HTMLDivElement>;

    const lastSlideElements = this.myRef.querySelectorAll(
      `[data-swiper-slide-index='${length - 1}']`,
    ) as NodeListOf<HTMLDivElement>;

    const dispatchEvent = (element: HTMLDivElement, evt: MouseEvent) => {
      const { position } = this.props;
      const ev = new Event("click", {
        bubbles: true,
      });

      window.localStorage.setItem("pageX", `${evt.pageX}`);
      window.localStorage.setItem("pageY", `${evt.pageY}`);
      window.localStorage.setItem("position", `${position}`);
      (element.firstChild as HTMLElement).dispatchEvent(ev);
    };

    const dispatchFirstElement = (evt: MouseEvent) => {
      dispatchEvent(firstSlideElements[firstSlideElements.length - 2], evt);
    };

    const dispatchLastElement = (evt: MouseEvent) => {
      dispatchEvent(lastSlideElements[1], evt);
    };

    this.dispatchFirstElement = dispatchFirstElement;
    this.dispatchLastElement = dispatchLastElement;

    this.firstElement = firstSlideElements[firstSlideElements.length - 1];
    this.firstElement.removeEventListener("click", this.dispatchFirstElement);
    this.firstElement.addEventListener(
      "click",
      this.dispatchFirstElement,
      false,
    );

    if (length > 1) {
      this.lastElement = lastSlideElements[0];
      if (this.lastElement) {
        this.lastElement.removeEventListener("click", this.dispatchLastElement);
        this.lastElement.addEventListener(
          "click",
          this.dispatchLastElement,
          false,
        );
      }
    }
  };

  public componentDidMount() {
    const { option, id } = this.props;
    this.option = Object.assign({}, DEFAULT_OPTION, option);
    this.mySwiper = new Swiper(`#${id}`, this.option);
  }
  public componentDidUpdate() {
    const { option, id } = this.props;
    this.option = Object.assign({}, DEFAULT_OPTION, option);
    this.mySwiper.destroy(true, false);
    this.mySwiper = new Swiper(`#${id}`, this.option);

    this.bindElementEvent();
  }

  public componentWillUnMount() {
    this.mySwiper.destroy(true, true);

    this.firstElement &&
      this.firstElement.removeEventListener("click", this.dispatchFirstElement);

    this.lastElement &&
      this.lastElement.removeEventListener("click", this.dispatchLastElement);
  }

  public render() {
    const { children, className = "", id } = this.props;
    const mergeClassName = classnames("swiper-container", className);
    return (
      <div className={mergeClassName} id={id} ref={(e) => (this.myRef = e)}>
        <div className="swiper-wrapper">{children}</div>
        <div className="swiper-pagination" />
        <i className="swiper-button-prev" />
        <i className="swiper-button-next" />
      </div>
    );
  }
}
